import PropTypes from 'prop-types';
import { components } from 'react-select';

import { Box } from '@hivebrite/design-system/Box';
import { ReactSelectAsyncWithAxios } from '@hivebrite/design-system/Inputs';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import CompanyLogo from 'hb-react/shared/components/CompanyLogo';

const Option = (props) => {
  const {
    data: {
      logo_url: logoUrl,
      name,
      inline_location: inlineLocation,
      __isNew__,
    },
    isFocused,
    isSelected,
    label,
    data,
    options,
  } = props;

  return (
    <li
      aria-posinset={data.id}
      aria-selected={isSelected}
      aria-setsize={options.length}
      role="option"
      tabIndex={-1}
      data-testid="react-select-option"
    >
      <components.Option {...props}>
        {__isNew__ ? (
          <div data-testid="react-select-creatable">{label}</div>
        ) : (
          <div className="flex">
            {logoUrl && (
              <div style={{ marginRight: '12px' }}>
                <CompanyLogo src={logoUrl} name={name} small />
              </div>
            )}
            <div>
              <div>{name}</div>
              {inlineLocation && (
                <Box
                  display="block"
                  font="metadata-regular-dove"
                  color={isSelected || isFocused ? 'white' : undefined}
                  mt={1}
                >
                  {inlineLocation}
                </Box>
              )}
            </div>
          </div>
        )}
      </components.Option>
    </li>
  );
};

const noOptionsMessage = ({ inputValue }) =>
  inputValue
    ? __('Company %{company} not found').i__({
        company: inputValue,
      })
    : __('Search for a company');

const ReactSelectCompanies = ({
  placeholder,
  isMulti,
  multiple,
  ...otherProps
}) => {
  const { currentNetwork } = useDefaultAppContexts();

  return (
    <ReactSelectAsyncWithAxios
      loadOptionsUrl={Routes.search_companies_path({
        // We need to pass network_id for usage from PO when customer is not authenticated.
        network_id: currentNetwork?.id,
        format: 'json',
      })}
      placeholder={placeholder || __('Companies')}
      noOptionsMessage={noOptionsMessage}
      components={{
        Option,
      }}
      multiple={multiple || isMulti}
      {...otherProps}
    />
  );
};

ReactSelectCompanies.propTypes = {
  placeholder: PropTypes.string,
};

export default ReactSelectCompanies;
